import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/context";
import { Reveal } from "./Reveal";

export const Faq = () => {
    const { t } = useLang();
    return (
        <section id="faqs" data-testid="faq-section" className="py-20 sm:py-28">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="text-center">
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#2A0505]">{t.faq.heading}</h2>
                    <p className="text-base sm:text-lg text-[#6B5B57] mt-4">{t.faq.sub}</p>
                </Reveal>
                <Reveal delay={0.15}>
                    <Accordion type="single" collapsible className="mt-10 space-y-3">
                        {t.faq.items.map((item, i) => (
                            <AccordionItem
                                key={i}
                                value={`faq-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="rounded-2xl border border-[#EADFD8] bg-white px-6 overflow-hidden"
                            >
                                <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-display text-base sm:text-lg font-bold text-[#2A0505] hover:text-[#8D1717] hover:no-underline py-5">
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent data-testid={`faq-answer-${i}`} className="text-sm sm:text-base text-[#6B5B57] leading-relaxed pb-5">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
};
